import React, {useEffect, useState} from 'react';
import './styles.css';
import { ReactComponent as GeoPointAsia } from '../../icons/geo-point-red.svg';
import { ReactComponent as GeoPointGras } from '../../icons/geo-point-green.svg';
import { ReactComponent as VectorAsia } from '../../icons/vector-red.svg';
import { ReactComponent as VectorGras } from '../../icons/vector-green.svg';
import {toastr} from "react-redux-toastr";


import 'semantic-ui-css/semantic.min.css'
import {Dimmer, Flag, Loader, Modal, ModalContent} from "semantic-ui-react";
import {useSelector} from "react-redux";

import {useParams} from "react-router";
import {getExponents, getExponentsFetching} from "../Exponents/reducer";
import {closeSearchInput, EXPONENTS_PAGE_COUNT, fetchExponents, setTitle, setURL} from "../Exponents/action";
import BookmarkComponent from "../../components/Bookmark";
import {getLanguage} from "../../components/LanguageModal/reducer";
import translations from "../../components/LanguageModal/translations";
import SadIconAsia from "../../icons/sad-icon.png";
import SadIconGras from "../../icons/sad-icon-green.png";
import FormMeeting from "../../components/FormMeeting";

import { ReactComponent as DownloadIcon} from "../../icons/download-presentation-icon.svg";
import { ReactComponent as WatchIcon} from "../../icons/check-icon.svg";
import { ReactComponent as VectorIconAsia} from "../../icons/vector-expo-red.svg";
import { ReactComponent as VectorIconGras} from "../../icons/vector-expo-green.svg";
import {getTypeExhibition} from "../Home/reducer";
import UnloginPopup from "../../components/UnloginPopup";

export default function ExponentCard(props) {

    const { dispatch, userData, token, mixpanel } = props;
    const exponents = useSelector((state) => getExponents(state.exponents));
    const isFetching = useSelector((state) => getExponentsFetching(state.exponents));
    const typeExhibition = useSelector((state) => getTypeExhibition(state.exhibition));

    const dataExhibition = {
        asia: {
            geoIcon: (props) => <GeoPointAsia  {...props} />,
            vectorIcon: (props) => <VectorAsia {...props} />,
            vectorDownIcon: (props) => <VectorIconAsia {...props} />,
            sadIcon: SadIconAsia,
        },
        gras: {
            geoIcon: (props) => <GeoPointGras  {...props} />,
            vectorIcon: (props) => <VectorGras {...props} />,
            vectorDownIcon: (props) => <VectorIconGras {...props} />,
            sadIcon: SadIconGras,
        }
    }

    const [open, setOpen] = useState(false)
    const [openLogin, setOpenLogin] = useState(false)

    const [isPopupOpen, setIsPopupOpen] = useState(false);

    const { exponentId } = useParams();

    let exponentToDisplay = exponents ? exponents.find((exponent) => exponent.id === exponentId) : null;

    const language = useSelector(getLanguage);
    const languageString = language[0]+language[1];
    const t = (key) => {
        const languageString = language[0]+language[1];
        const translation = translations[languageString];
        return translation ? translation[key] || key : key;
    };
    // console.log(exponentToDisplay)
    useEffect(() => {
        window.scrollTo(0, 0);
        const params = {
            page: 1,
            per_page: EXPONENTS_PAGE_COUNT,
            order: "asc",
            orderby: "id",
            event: "ASIAEXPO 2024",
            id: exponentId,
            user_id: userData.id,
            lang: languageString,
        };
        dispatch(fetchExponents(token, params));

        if (mixpanel) {
            mixpanel.track('View. Exponent page')
        }

    }, [exponentId]);

    const ExponentCard = (props) => {
        const { exponent, navigate, mixpanel, typeExhibition, dataExhibition } = props;



        // const handlePresentationClick = () => {
        //     window.open(exponent.promo_docs[1].url, '_blank');
        // };

        const archive = exponent.events && exponent.events.archive;
        let locationExponent = '';

        if (archive) {
            const asiaExpo2024Event = archive.find(event => event.event === "ASIAEXPO 2024");

            if (asiaExpo2024Event) {
                locationExponent = asiaExpo2024Event.stand_number;
            } else {
                locationExponent = archive.map(elem => elem.stand_number).join(", ");
            }
        }
        const usersExponent = exponentToDisplay.users && exponentToDisplay.users.map((elem, index) => {
            return {
                key: elem.id,
                value: {...elem},
                text: languageString === "ru" ?
                        elem.first_name + " " + elem.last_name + " - " + elem.job_title
                    :
                        elem.first_name_en + " " + elem.last_name_en + " - " + elem.job_title_en
            }});

        const GeoPoint = (props) => (dataExhibition[typeExhibition].geoIcon(props))
        const Vector = (props) => (dataExhibition[typeExhibition].vectorIcon(props))
        const VectorIcon = (props) => (dataExhibition[typeExhibition].vectorDownIcon(props))

        return (
            <div className="body_expo_card">
                <div>
                    <img src={exponent.logo} className="image_expo_card" alt="Image_expo_card"/>
                    <div className="info_expo_card">
                        <div className="flag_expo_card">
                            <BookmarkComponent
                                bookmark_using_for="exponents"
                                id={exponent.id}
                                {...props}
                            />
                        </div>
                        <div className="text_expo_card">
                            <GeoPoint className="geo-point_expo_card" alt="Geo-point_expo_card"/>
                            <div className={`location_expo_card ${typeExhibition}`}>{locationExponent}</div>
                            <Flag name={exponent.country.toLowerCase()} className="country_Russia_exp card-expo"/>

                        </div>

                        <div
                            className="name_expo_card">{languageString === "en" ? exponent.name_en : exponent.name}</div>
                        <div className="company_info_expo_card"
                             dangerouslySetInnerHTML={{__html: languageString === "en" ? exponent.content_en : exponent.content}}>
                        </div>
                        <div className='container-exponents buttons'>
                            {typeExhibition === 'asia' && <div className="stries_expo_card"
                                  onClick={() => navigate(`/exposition/`)}>
                                <span>{t("lookExposition")}</span>
                                <Vector className="vector_expo_card" alt="Vector_expo_card"/>
                            </div>}
                            <Modal
                                open={isPopupOpen}
                                className='exponent-card-popup'
                                trigger={
                                    <div
                                        onClick={!token ? () => setOpenLogin(true) : () => setIsPopupOpen(true)}
                                        className="stries_expo_card">{t("appointMeet")}
                                        <Vector className="vector_expo_card" alt="Vector_expo_card"/>
                                    </div>
                                }
                                onClose={() => setIsPopupOpen(false)}
                                centered
                            >
                                <ModalContent>
                                    <FormMeeting
                                        company={exponent}
                                        handleClose={() => setIsPopupOpen(false)}
                                        persons={usersExponent}
                                        stand={locationExponent}
                                        token={token}
                                    />
                                </ModalContent>
                            </Modal>
                            <div
                                className="stries_expo_card_link"
                                onClick={() => {
                                    if (exponent.url) {
                                        let fixedUrl = exponent.url;
                                        if (!fixedUrl.startsWith('http://') && !fixedUrl.startsWith('https://')) {
                                            fixedUrl = `https://${fixedUrl.replace(/^www\./, '')}`;
                                        }
                                        window.open(fixedUrl, '_blank', 'noopener,noreferrer');
                                    }
                                }}
                                style={{cursor: 'pointer'}}
                                role="button"
                                tabIndex={0}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                        e.preventDefault();
                                        if (exponent.url) {
                                            let fixedUrl = exponent.url;
                                            if (!fixedUrl.startsWith('http://') && !fixedUrl.startsWith('https://')) {
                                                fixedUrl = `https://${fixedUrl.replace(/^www\./, '')}`;
                                            }
                                            window.open(fixedUrl, '_blank', 'noopener,noreferrer');
                                        }
                                    }
                                }}
                            >
                                <div className="stries_expo_card">
                                    <span>{t("toWebSite")}</span>
                                    <Vector className="vector_expo_card" alt="Vector_expo_card"/>
                                </div>
                            </div>
                            <div className="stries_expo_card" onClick={() => setOpen(!open)}>{t("lookPresentation")}
                                {!open ? <Vector className="vector_expo_card" alt="Vector_expo_card"/> :
                                    <VectorIcon className="vector_expo_card" alt="Vector_expo_card"/>}

                            </div>
                        </div>


                        <div className='container-watch-presents'>
                            {open ? exponent.promo_docs.map(function (docs) {
                                return (
                                    <div className="container-present">
                                        <span className='text-presentation'>{docs.title}</span>
                                        <div className="presentation-icons">
                                            <WatchIcon className="watch-icon" onClick={() => {
                                                dispatch(setTitle(docs.title))
                                                dispatch(setURL(docs.url))
                                                navigate('/exponent-presentation')
                                            }}/>
                                            <DownloadIcon className="watch-icon" onClick={async () => {
                                                const response = await fetch(docs.url);
                                                const blob = await response.blob();

                                                const link = document.createElement('a');
                                                link.href = window.URL.createObjectURL(blob);
                                                link.download = docs.title;
                                                document.body.appendChild(link);
                                                link.click();
                                                document.body.removeChild(link);
                                                if (mixpanel) {
                                                    mixpanel.track('Action. Download presentation of exponent')
                                                }
                                            }}/>
                                        </div>
                                    </div>

                                )
                            }) : ''}

                            {open && exponent.promo_docs.length === 0 ? (
                                <div className="container-present-not">
                                    <div className='view-presentations'>
                                        <img width={50} height={50} src={dataExhibition[typeExhibition].sadIcon} alt={""}/>
                                        <span className='text-bookmark'>{t("noPresentations")}</span>
                                    </div>
                                </div>) : ''}
                        </div>


                    </div>
                    <div className={`red_expo_card ${typeExhibition}`}>
                        {t("segments")}
                    </div>
                    <div className="segments_expo_card">
                        {exponent.segments && exponent.segments.map((segment, index) => (
                            <>
                                    <span
                                        key={index}
                                        className='underline_expo_card'
                                        onClick={() => navigate(`/exponents/${segment.id}`)}
                                    >
                                         <span
                                             className={`dot ${typeExhibition}`}>•</span> {languageString === "ru" ? segment.name : segment.name_en}
                                        </span>
                                </>
                            ))}
                    </div>


                </div>
            </div>

        );
    };


    return (
        <div>
            <Dimmer className="page-loader" active={isFetching} inverted>
                <Loader active>{t("loadInfo")} ...</Loader>
            </Dimmer>
            {exponentToDisplay ? (
                <ExponentCard
                    key={exponentToDisplay.id}
                    exponent={exponentToDisplay}
                    showLoader
                    typeExhibition={typeExhibition}
                    dataExhibition={dataExhibition}
                    {...props}
                />
            ) : (
                <div className='view-bookmarks'>
                    <img src={SadIcon} alt={""}/>
                    <span className='text-bookmark'>{t("notExponents")}</span>
                </div>
            )}
            <UnloginPopup open={openLogin} setOpen={setOpenLogin} text={t('meetReg')} />
        </div>
    );
}
